var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
export var useImageUpload = function (initial) {
    var _a = __read(React.useState(initial.file), 2), file = _a[0], setFile = _a[1];
    var _b = __read(React.useState(initial.image), 2), image = _b[0], setImage = _b[1];
    React.useEffect(function () {
        if (file) {
            var reader_1 = new FileReader();
            reader_1.addEventListener("loadend", function () { return setImage(reader_1.result); });
            reader_1.readAsDataURL(file);
        }
    }, [file]);
    var onImageChange = function (evt) {
        var files = evt.target.files;
        if (files && files.length > 0) {
            setFile(files[0]);
        }
        else {
            setFile(null);
        }
    };
    var resetImage = function () { return setImage(null); };
    var resetFile = function () { return setFile(null); };
    return {
        image: image,
        onImageChange: onImageChange,
        resetImage: resetImage,
        resetFile: resetFile,
        setImage: setImage,
        file: file,
    };
};
